import { faBan, faCheck, faTrash, faWandMagicSparkles } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "react-bootstrap";
import {
    RecordLifecycleActionLabels,
    type RecordLifecycleConfirmKind,
} from "../../utils/navigation/recordLifecycleActions";

export type RecordLifecycleActionKind = RecordLifecycleConfirmKind;

export function shouldShowEditFormLifecycleActions(
    isNew: boolean,
    recordId: string | undefined,
    isNarrowScreen: boolean
): boolean {
    return !isNew && Boolean(recordId?.trim()) && !isNarrowScreen;
}

/** Enable / disable / delete / restore buttons for edit-form footers (wide layout). */
export function EditFormLifecycleActions({
    metaDeleted,
    metaEnabled,
    onAction,
    showDeleteRestore = true,
}: {
    metaDeleted: boolean;
    metaEnabled: boolean;
    onAction: (kind: RecordLifecycleActionKind) => void;
    /** When false, only Enable/Disable are shown (e.g. municipal/degradable indicators). */
    showDeleteRestore?: boolean;
}) {
    if (metaDeleted) {
        return (
            <Button
                variant="outline-success"
                type="button"
                className="d-inline-flex align-items-center gap-2"
                onClick={() => onAction("restore")}
            >
                <FontAwesomeIcon icon={faWandMagicSparkles} aria-hidden />
                {RecordLifecycleActionLabels.restore}
            </Button>
        );
    }

    return (
        <>
            {metaEnabled ? (
                <Button
                    variant="outline-warning"
                    type="button"
                    className="d-inline-flex align-items-center gap-2"
                    onClick={() => onAction("disable")}
                >
                    <FontAwesomeIcon icon={faBan} aria-hidden />
                    {RecordLifecycleActionLabels.disable}
                </Button>
            ) : (
                <Button
                    variant="outline-primary"
                    type="button"
                    className="d-inline-flex align-items-center gap-2"
                    onClick={() => onAction("enable")}
                >
                    <FontAwesomeIcon icon={faCheck} aria-hidden />
                    {RecordLifecycleActionLabels.enable}
                </Button>
            )}
            {showDeleteRestore && (
                <Button
                    variant="outline-danger"
                    type="button"
                    className="d-inline-flex align-items-center gap-2"
                    onClick={() => onAction("softDelete")}
                >
                    <FontAwesomeIcon icon={faTrash} aria-hidden />
                    {RecordLifecycleActionLabels.delete}
                </Button>
            )}
        </>
    );
}
